import { createApi, createDomain } from 'effector';
import type { PanelType } from '@types';

const domain = createDomain('panel');

interface PBasic {
  type?: Exclude<PanelType, PanelType.customGroup | PanelType.customButton>;
}
interface PCustomGroup {
  type: PanelType.customGroup;
  groupIndex: number;
  isNew?: boolean;
}
interface PCustomButton {
  type: PanelType.customButton;
  groupIndex: number;
  buttonIndex: number;
  isNew?: boolean;
}

type PanelState = PBasic | PCustomGroup | PCustomButton;

export const $panel = domain.store<PanelState>({});

export const $panelApi = createApi($panel, {
  show: (store, e: PanelState) => e,
  dismiss: () => ({}),
});
